import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MemberPersonalInformationOnboardingFormGroup } from '../member-personal-information-onboarding-form-group';
import { Country } from '../../../../../models/types/dto/country';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PhoneDropdownItem } from '../../../../../models/shared/phone-dropdown-item';

@Component({
  selector: 'app-member-onboarding-modal-contact-information-form',
  templateUrl: './member-onboarding-modal-contact-information-form.component.html',
  styleUrls: ['./member-onboarding-modal-contact-information-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MemberOnboardingModalContactInformationFormComponent implements OnChanges {
  @Input() form!: MemberPersonalInformationOnboardingFormGroup;
  @Input() formSubmitted: boolean = false;
  @Input() countries: Country[] = [];

  private _countries = new BehaviorSubject<Country[]>([]);
  public countries$ = this._countries as Observable<Country[]>;

  public countryCodes$ = this.countries$.pipe(
    map(countries => countries.map(country => new PhoneDropdownItem(country)))
  );

  public customErrorMessages = {
    primaryPhoneNumber: {
      required: $localize`Primary Phone Number is required`
    }
  };

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.countries) {
      this._countries.next(this.countries);
    }
  }
}
